export const formatTime = (input: string): string | null => {
  // Поиск времени (может быть частично введено)
  const timeRegex = /(\d{1,2}):?(\d{0,2})?/
  const timeMatch = input.match(timeRegex)

  let formattedTime = ''
  if (timeMatch) {
    let [, hours, minutes] = timeMatch

    if (hours.length === 1 && input.match(/^\d:/)) {
      // Если введена одна цифра и сразу после нее идет ":", добавляем 0 перед часами
      hours = '0' + hours
    }

    if (minutes === undefined && hours.length === 2 && !input.includes(':')) {
      // Если введены две цифры без ':', добавляем ':' в конец
      formattedTime = hours + ':'
    } else {
      formattedTime = hours + (minutes ? ':' + minutes : '')
    }
  }

  return formattedTime.trim()
}
